import { CAT_INGREDIENT_CATEGORIES } from 'App/utils/Collections';

export default {
  category: CAT_INGREDIENT_CATEGORIES,
  filters: [],
  searchBarProp: 'translations.name',
};
